import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AngularMaterialModule } from 'src/app/angular-material.module';
import { ServiceOrdersTotalizersModule } from "../../../views/registration/service-orders/service-orders-totalizers/service-orders-totalizers.module";
import { ChatModule } from '../chat-widget/chat-message.module';
import { CardGridResponsive } from './card-grid-responsive.component';

@NgModule({
    declarations: [CardGridResponsive],
    imports: [
        CommonModule,
        AngularMaterialModule,
        FormsModule,
        ReactiveFormsModule,
        FlexLayoutModule,
        ChatModule,
        ServiceOrdersTotalizersModule
    ],
    exports: [CardGridResponsive],
})
export class CardGridResponsiveModule { }
